import React, {useEffect, useState} from "react";
import {useAppSelector} from "../../../../hooks/useAppSelector";
import {TableFilterKey} from "../../../../model/filters/TableFiltersDefinitions";
import {useFiltersActions} from "../../../../hooks/useFiltersActions";
import {SearchInput} from "../SearchInput";

interface Props {
    tableFilterKey: TableFilterKey,
    filterFieldName: string;
}

export const TableColumnPopupContent = ({filterFieldName, tableFilterKey}: Props) => {
    const {updateFilterAndClearData} = useFiltersActions();
    const state = useAppSelector(state => state.sessionStorage.filters);
    const filter = state[tableFilterKey].filter;
    // @ts-ignore
    const [search, setSearch] = useState<string>(filter[filterFieldName] ?? '');

    function onSearchInput(text: string | null) {
        setSearch(text || "");
    }

    useEffect(() => {
        // @ts-ignore
        if (search === filter[filterFieldName]) return;
        // @ts-ignore
        setSearch(filter[filterFieldName] || '')
        // @ts-ignore
    }, [filter[filterFieldName], filterFieldName]);

    useEffect(() => {
        // @ts-ignore
        if (search === filter[filterFieldName]) return;
        let timerForSearchDebounce = setTimeout(() => {
            const newFilter = {...filter, pageNumber: 0};
            // @ts-ignore
            newFilter[filterFieldName] = search;
            updateFilterAndClearData({
                key: tableFilterKey,
                value: newFilter,
            })
        }, 2000);
        return () => {
            clearTimeout(timerForSearchDebounce);
        };
    }, [search]);

    return (
        <SearchInput placeholder="Поиск" onChange={onSearchInput} value={search}/>
    );
};